import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import Switch from "react-switch";
import { Row, Col } from 'react-bootstrap'
import './styles.scss'
import { AiFillEdit } from 'react-icons/ai'
import { store } from 'react-notifications-component';

export class Main extends React.Component{
    state={
        error: false,
        signin: true,
        darkTheme: false
    }
    

    componentDidMount(){    
        document.title= "Postavke"   
    }

    handleColapsed(){    
        this.props.toggleSettings("ASIDE_COLAPSED")
    }

    handleBG() {
        this.props.toggleSettings("ASIDE_BG")
    }

    changeTheme = async () => {
        this.setState({
            darkTheme: !this.state.darkTheme
        })

        await this.props.toggleSettings("DARK_THEME_TOGGLER")

        document.documentElement.className = "";
        

        if(this.props.darkTheme){
            document.documentElement.classList.add(`theme-dark`);
        }
        else{
            document.documentElement.classList.add(`theme-light`);
        }      
    };

    onFileChange = async event => { 
        await this.props.mapState("CUSTOM_INVOICE_FILE", event.target.files[0])
    };

    generickiPredlozak(e){

        if(this.props.customInvoiceFile.length !== 0){
            this.props.toggleSettings("GENERICKI_PREDLOZAK_RACUNA")
        }
        else{
            store.addNotification({
                title: "Greška!",
                message: "Nema izrađeog predloška",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
       
    }

    downloadPredlozak= () => {
        fetch('http://localhost:8080/employees/download')
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = 'employees.json';
                    a.click();
                });
                //window.location.href = response.url;
        });

    }

    izradiPredlozak(){
        window.location = "#/Client/settings/predlozakRacuna"
    }


    render(){        
        return(     
            <main style={{height: "auto"}}>
                <header>
                    <h1>
                        POSTAVKE
                    </h1>
                </header>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2 style={{width: "200px", borderBottom: "1px solid lightgray"}}>Izbornik</h2>         
                            
                            <br/>                         
                            <Row >
                                <Col style={{display: "inline-flex"}}>
                                    <Switch onChange={(e) => this.handleColapsed(e)} checked={this.props.asideColapsed} />
                                    <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Bez Naziva</h3>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col style={{display: "inline-flex"}}>
                                    <Switch onChange={() => this.handleBG()} checked={this.props.asideBg} />
                                    <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Pozadinska slika</h3>
                                </Col>
                            </Row>

                            <br/>

                            <Row>
                                <Col style={{display: "inline-flex"}}>
                                    <Switch onChange={(e) => this.changeTheme(e)} checked={this.props.darkTheme} />
                                    <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Tamna tema</h3>
                                </Col>
                            </Row>

                            <br/>
                           
                        </div>
                        
                        <div className="col">
                            <h2 style={{width: "200px", borderBottom: "1px solid lightgray", marginBottom:"20px"}}>Računi (Predložak)</h2>         
                            
                            <br/>

                            <Row>
                                <Col style={{display: "inline-flex"}}>
                                    <Switch onChange={(e) => this.generickiPredlozak(e)} checked={this.props.generickiPredlozakRacuna} />
                                    <h3 style={{marginBottom: "0px", display: "flex", alignItems: "center", marginLeft: "20px"}}>Generički predložak</h3>
                                </Col>
                            </Row>

                            <br/>

                            <Row>
                                <Col style={{display: "inline-flex"}}>
                                    <label style={{alignSelf: "center"}}>Izradi predložak: &nbsp;&nbsp;&nbsp;</label>
                                    <div 
                                        className="btn btn-warning"                                          
                                        onClick={() =>this.izradiPredlozak()} 
                                        style={{marginBottom: "10px", marginRight: "10px"}}
                                    > 
                                        <AiFillEdit /> Izradi 
                                    </div>  
                                </Col>  
                            </Row> 
                        </div>
                    </div>
                </div>
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideColapsed: state.clientSettings.asideColapsed,
        asideBg: state.clientSettings.asideBg,
        darkTheme: state.clientSettings.darkTheme,
        generickiPredlozakRacuna: state.clientSettings.generickiPredlozakRacuna,
        customInvoiceFile: state.clientSettings.customInvoiceFile
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data}),
      toggleSettings: (type) => dispatch({ type: type})  
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main);
